import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canPasteTreeAsAr, pasteTreeAsAr} = map.commands
    const nodes = canPasteTreeAsAr(selectedNodes)

    return {
        disabled: 0 === nodes.length,
        key: 'paste-tree-as-ar',
        label: '粘贴为描述',
        suffix: 'Ctrl+Alt+V',
        onClick: () => pasteTreeAsAr(nodes),
    }
}
